let Masonry = require('masonry-layout');

$(document).ready(function () {

    let searchRequest = null,
        originalNavHtml = null;

    function showSearchNav(html) {
        let $nav = $('.browse-navigation');

        if (originalNavHtml === null) {
            originalNavHtml = $nav.html();
        }

        $nav.attr('data-search-active', 'true').html(html);
    }

    function restoreBrowseNav() {
        if (originalNavHtml !== null) {
            $('.browse-navigation').removeAttr('data-search-active').html(originalNavHtml);
            originalNavHtml = null;
        }
    }

    function disableTableResize() {
        if (typeof disableResizableTables === 'function') {
            disableResizableTables();
        }
    }

    function showLoader() {
        if (typeof showLoadingOverlay === 'function') {
            showLoadingOverlay();
        }
    }

    function hideLoader() {
        if (typeof hideLoadingOverlay === 'function') {
            hideLoadingOverlay();
        }
    }

    function enableTableResize() {
        if (typeof initResizableTables === 'function') {
            initResizableTables($('.lazy-load-table'));
        }
    }

    function clearSearchResults() {
        $('.search-table').remove();
        $('.browse-cards.searched').remove();
        $('.no-results').remove();
    }

    function performSearch(page) {
        let $input = $('#search-records:not([data-view="calendar"])');

        if (!$input.length) {
            return;
        }

        let query = $input.val().trim(),
            table_id = $input.attr('data-table-id'),
            $table = $('.browse-table'),
            $search_all = $('#search-all'),
            $table_container = $('.table_container:not(.button-container)'),
            $browse_cards = $('.browse-cards'),
            view = $('.page-container').attr('data-view-type'),
            $filter = $('.filter-icons'),
            $items_select = $('#search-pagination-items'),
            items = $items_select.length ? $items_select.val() : null,
            filter = '';

        if ($filter.length) {
            filter = $filter.attr('data-filter-id');
        }

        // Kanban columns reload their own records with the search applied (kanban.js)
        if (view === 'kanban') {
            $(document).trigger('kanban:search', [query, $search_all.is(':checked') ? 'yes' : 'no']);
            return;
        }

        if (searchRequest) {
            searchRequest.abort();
        }

        if (!query.length) {
            clearSearchResults();
            $table.removeClass('d-none');
            $browse_cards.removeClass('d-none');
            hideLoader();
            restoreBrowseNav();
            enableTableResize();
            return;
        }

        showLoader();
        disableTableResize();

        searchRequest = $.ajax({
            type: 'GET',
            url: '/search/',
            data: {
                search: query,
                table_id: table_id,
                search_all: $search_all.is(':checked') ? 'yes' : 'no',
                view,
                filter,
                page: page || 1,
                items
            },
            complete: function () {
                hideLoader();
            },
            success: function (results) {
                clearSearchResults();
                $table.addClass('d-none');
                $browse_cards.addClass('d-none');

                if (results) {
                    if (view === 'card') {
                        let $results = $(results.table).insertAfter($browse_cards);
                        $results.filter('.browse-cards').addClass('searched');
                        let msnry = new Masonry('.browse-cards.searched', {});
                    } else {
                        $table_container.append(results.table);
                    }
                    showSearchNav(results.nav);
                } else {
                    let message = `<div class="no-results text-center">No search results for <b>${query}</b></div>`;
                    if (view === 'card') {
                        $(message).insertAfter($browse_cards);
                    } else {
                        $table_container.append(
                            `<div class="no-results text-center">No search results for <b>${query}</b></div>`
                        );
                    }
                    showSearchNav('');
                }
            }
        });
    }

    $('#search-all').on('change', function () {
        performSearch(1);
    });

    $('.open-search').on('click', function (e) {
        setTimeout(function () {
            $('#search-records').focus();
        }, 0);
    });

    $('#search-records:not([data-view="calendar"])').on('keyup', delay(function (e) {
        performSearch(1);
    }, 300));

    $('#search-records:not([data-view="calendar"])').on('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            $(this).val('');
            performSearch(1);
        }
    });

    $(document).on('click', '.browse-navigation[data-search-active] .page-link', function (e) {
        e.preventDefault();
        let href = $(this).attr('href'),
            match = href ? href.match(/[?&]page=(\d+)/) : null,
            page = match ? parseInt(match[1], 10) : 1;

        performSearch(page);
    });

    $(document).on('change', '#search-pagination-items', function () {
        performSearch(1);
    });

    $('#find-company').on('click', function (e) {
        e.preventDefault();
        let $container = $('.create-field'),
            vat_no = $container.find('.data-input[name=vat_number]').val();

        if (!vat_no.length) {
            toastr.error(translation.select_vat_no);
        } else {
            $.ajax({
                type: 'GET',
                url: '/search/company',
                data: {
                    vat_no
                },
                success: function (res) {
                    if (!res) {
                        toastr.error(translation.invalid_vat_number);
                    } else {
                        renderCompanyFields(res, $container);
                    }
                }
            })
        }
    });

    $('#find-company-modal').on('click', function (e) {
        e.preventDefault();
        let $container = $('#create-modal'),
            vat_no = $container.find('.data-input[name=vat_number]').val();

        if (!vat_no.length) {
            toastr.error(translation.select_vat_no);
        } else {
            $.ajax({
                type: 'GET',
                url: '/search/company',
                data: {
                    vat_no
                },
                success: function (res) {
                    if (!res) {
                        toastr.error(translation.invalid_vat_number);
                    } else {
                        renderCompanyFields(res, $container);
                    }
                }
            })
        }
    });
});

function renderCompanyFields(fields, $container) {
    for (let key in fields) {
        let value = fields[key];
        if (key === 'tax_payer') {
            $($container).find(`input[name=${key}]`).prop('checked', value);
        } else if (key === 'billing_country') {
            let $target = $($container).find(`.hidden-relation[name="billing_country"]`);
            $target.val(value.id);
            $target.siblings('.relation-data-field').val(value.name);
            $target.closest('.form-group').addClass('control-highlight');
        } else {
            let $target = $($container).find(`.data-input[name=${key}]`);
            $target.val(value).trigger('keyup');
            $target.closest('.form-group').addClass('control-highlight');
        }
    }
}

function delay(callback, ms) {
    let timer = 0;
    return function () {
        let context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}